export default "__VITE_ASSET__680c0bd5__"